<div class="modal-header">
  <h5 class="modal-title">เลือกพิกัดจากแผนที่</h5>
  <button type="button" class="btn-close" aria-label="ปิด" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  @if (loadError) {
    <div class="alert alert-warning m-3">{{ loadError }}</div>
  } @else {
    <div class="map-shell" [class.is-loading]="isLoading">
      <div #mapContainer class="map-canvas"></div>

      <div class="map-tools" [class.is-readonly]="readOnly">
        <div class="map-form">
          <div class="search-panel">
            <div class="d-flex gap-2">
              <input
                type="text"
                class="form-control"
                placeholder="ค้นหาสถานที่หรือ Plus Code"
                [(ngModel)]="searchKeyword"
                (ngModelChange)="searchLocation()"
                [disabled]="readOnly">
              @if (searchKeyword && !readOnly) {
                <button type="button" class="btn btn-sm btn-light search-clear" (click)="clearSearchResults()">ล้าง</button>
              }
            </div>
            <div class="search-results" [class.is-visible]="showSearchResults">
              @if (searchError) {
                <div class="search-result-item is-placeholder">{{ searchError }}</div>
              } @else if (searching) {
                <div class="search-result-item is-placeholder">กำลังค้นหา...</div>
              } @else if (!searchResults.length) {
                <div class="search-result-item is-placeholder">ไม่พบสถานที่</div>
              } @else {
                @for (result of searchResults; track result.name) {
                  <div
                    class="search-result-item"
                    role="button"
                    tabindex="0"
                    (click)="selectSearchResult(result)"
                    (keydown.enter)="selectSearchResult(result)">
                    {{ result.name }}
                  </div>
                }
              }
            </div>
          </div>

          <div class="coordinate-panel" aria-label="พิกัดที่เลือก">
            <div class="coordinate-field">
              <label class="form-label" for="selectedLatitude">ละติจูด</label>
              <input id="selectedLatitude" type="text" class="form-control" [value]="selectedLatitude" readonly>
            </div>
            <div class="coordinate-field">
              <label class="form-label" for="selectedLongitude">ลองจิจูด</label>
              <input id="selectedLongitude" type="text" class="form-control" [value]="selectedLongitude" readonly>
            </div>
          </div>
        </div>
      </div>

      @if (isLoading) {
        <div class="map-loading">กำลังโหลดแผนที่...</div>
      }
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">
    {{ readOnly ? 'ปิด' : 'ยกเลิก' }}
  </button>
  @if (!readOnly) {
    <button type="button" class="btn btn-primary" (click)="confirmSelection()" [disabled]="!!loadError || isLoading">
      ใช้พิกัดนี้
    </button>
  }
</div>
